import { render, staticRenderFns } from "./CustomerCardForm.vue?vue&type=template&id=00f68b0e"
import script from "./CustomerCardForm.vue?vue&type=script&lang=js"
export * from "./CustomerCardForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerCardForm.vue?vue&type=style&index=0&id=00f68b0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports